import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="dark-mode".
// TailAdmin v4 uses `@custom-variant dark (&:is(.dark *))`, so dark styling is
// driven entirely by a `dark` class on <html>. The sun/moon icons swap via
// `dark:hidden` / `hidden dark:inline-block`, so the controller only needs to
// toggle that class and persist the choice.
export default class extends Controller {
  static targets = ["toggle"]

  connect() {
    this.apply(this.stored())
  }

  stored() {
    try {
      return JSON.parse(localStorage.getItem("darkMode") || "false") === true
    } catch {
      return false
    }
  }

  toggle(event) {
    if (event) event.preventDefault()
    const enabled = !document.documentElement.classList.contains("dark")
    localStorage.setItem("darkMode", JSON.stringify(enabled))
    this.apply(enabled)
  }

  apply(enabled) {
    document.documentElement.classList.toggle("dark", enabled)
    if (this.hasToggleTarget) this.toggleTarget.checked = enabled
  }
}
